import React, { Component } from 'react'

import DownshiftTypeahead from '../DownshiftTypeahead/'
import { compareHelpText } from '../../constants'
import styles from './styles.module.css'

export default class Controls extends Component {
  sourceOnPlaceChange(value) {
    const { onPlaceChange } = this.props
    onPlaceChange({ value, key: 'source' })
  }

  compareOnPlaceChange(value) {
    const { onPlaceChange } = this.props
    onPlaceChange({ value, key: 'compare' })
  }

  render() {
    const {
      places,
      /* isMobile, */
      source,
      compare,
      baseline,
      placeholderText
    } = this.props

    const invalidSelections = [source, compare, baseline]

    const placesLabels = places
      .map(place => {
        return {
          label: place
        }
      })
      // do not show currently selected places in the
      // dropdown menu
      .filter(place => !invalidSelections.includes(place.label))

    return (
      <div className={styles.controls}>
        <div className={styles.source}>
          <span className={styles.compareText}>Compare</span>
          <DownshiftTypeahead
            data={placesLabels}
            placeholderText={placeholderText}
            onChange={this.sourceOnPlaceChange.bind(this)}
            initialSelectedItem={source}
          />
        </div>
        <div className={styles.compare}>
          <span className={styles.compareText}>with</span>
          <DownshiftTypeahead
            data={placesLabels}
            placeholderText={placeholderText}
            onChange={this.compareOnPlaceChange.bind(this)}
            initialSelectedItem={compare}
          />
        </div>
        <div className={styles.compareText}>{compareHelpText}</div>
      </div>
    )
  }
}
